import {getRandomName} from "../utils/Randomname"


export const getUserName = () => {

  let name = localStorage.getItem("omore_user_name");

  if (!name) {
    name = getRandomName();
    localStorage.setItem("omore_user_name", name);
  }

  return name;
};